import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import CheckEligibility from '../../services/check-eligibility.service';
import { AnalyticsService } from '../../services/analytics.service';
import { TooltipsService } from '../../services/tooltips.service';
import './detailed-product-card-exchange.component.scss';
import axios from 'axios';
import * as $ from 'jquery';
var DetailedProductCardExchange = /** @class */ (function (_super) {
    tslib_1.__extends(DetailedProductCardExchange, _super);
    function DetailedProductCardExchange(element) {
        return _super.call(this, element) || this;
    }
    DetailedProductCardExchange.prototype.init = function () {
        // referral
        this.checkEligibility = new CheckEligibility();
        var pattern = /[?&]ifa=/;
        var getUrl = location.search;
        if (pattern.test(getUrl)) {
            this.queryStringValue = this.urlParams('ifa');
            this.queryStringCheck = true;
        }
        else {
            this.queryStringCheck = false;
        }
        this.supportedCurrenciesRendered = false;
        var storageCurrency = localStorage.getItem('currency');
        var storageEligibility = localStorage.getItem('eligibility');
        this.productKey = this.element.getAttribute('data-productkey');
        this.containerCurrencies = Array.from(this.element.querySelectorAll('.detailed-product-card-exchange__currencies--items'));
        this.currencyButtons = Array.from(this.element.querySelectorAll('.detailed-product-card-exchange__currencies--item'));
        this.containerButtons = Array.from(this.element.querySelectorAll('.detailed-product-card-exchange__buttons-js'));
        this.currencyPricingCards = Array.from(this.element.querySelectorAll('.detailed-product-card-exchange__currency-js'));
        this.containerEligibilityMessage = this.element.querySelector('.detailed-product-card-exchange__eligibility-message');
        this.currencyPricingTerms = Array.from(this.element.querySelectorAll('.product-offering-exchange__terms'));
        if (!storageCurrency) {
            storageCurrency = {};
            storageCurrency = "";
            localStorage.setItem('currency', JSON.stringify(storageCurrency));
        }
        else {
            storageCurrency = JSON.parse(storageCurrency);
            if (!storageCurrency) {
                storageCurrency = "";
                localStorage.setItem('currency', JSON.stringify(storageCurrency));
            }
        }
        if (!storageEligibility) {
            storageEligibility = {};
            localStorage.setItem('eligibility', JSON.stringify(storageEligibility));
        }
        else {
            storageEligibility = JSON.parse(storageEligibility);
        }
        this.currencyStorage = storageCurrency;
        this.eligibilityStorage = storageEligibility;
        this.currencySelected();
        this.currencyCards();
        this.buttonContainer(this.eligibilityStorage);
        TooltipsService.initTooltips();
    };
    DetailedProductCardExchange.prototype.bindEvents = function () {
        var _this = this;
        if (this.currencyButtons) {
            this.currencyButtons.map(function (item) { return item.addEventListener('click', function (event) {
                _this.currencyClick(event);
            }); });
        }
        $(document).on('click', '.js-recheck-eligibility', function (e) {
            var element = e.target;
            _this.recheckEligibility(element);
        });
        $(document).on('click', 'div.detailed-product-card-exchange__buttons-js[data-buttonclass=Apply]', function (e) {
            var element;
            if (e.currentTarget) {
                element = e.currentTarget;
            }
            else {
                element = e.target;
            }
            var getAnchor = element.querySelector('a');
            var getLeadId = getAnchor.getAttribute('data-leadid');
            var getProductName = getAnchor.getAttribute('data-productname');
            // APPLICATION ID
            var valueProductID = $(element).closest('.js-product-id').attr('data-productid');
            var valueEligibilityFormID = $(element).closest('.js-product-id').find('div[data-buttonclass=Eligibility]').find('.js-apply-now-modal-open').attr('data-modal');
            console.log('Modal ID', valueEligibilityFormID);
            console.log('Product ID', valueProductID);
            _this.checkEligibility.checkApplicationID(valueEligibilityFormID, valueProductID);
            _this.actionApplyNow(getLeadId, getProductName);
        });
    };
    DetailedProductCardExchange.prototype.currencyClick = function (event) {
        if (event) {
            var element = event.target;
            var currency = element.getAttribute('data-currency');
            this.currencyButtons.forEach(function (button) {
                button.classList.remove('detailed-product-card-exchange__currencies--item__active');
            });
            element.classList.add('detailed-product-card-exchange__currencies--item__active');
            this.currencyStorage = currency;
            localStorage.setItem('currency', JSON.stringify(this.currencyStorage));
            this.currencyCards(currency);
        }
    };
    DetailedProductCardExchange.prototype.currencySelected = function () {
        var _this = this;
        this.currencyButtons.map(function (element) {
            var currency = element.getAttribute('data-currency');
            if (currency == _this.currencyStorage) {
                element.classList.add('detailed-product-card-exchange__currencies--item__active');
            }
        });
    };
    DetailedProductCardExchange.prototype.currencyCards = function (currency) {
        var _this = this;
        if (currency === void 0) { currency = ''; }
        this.currencyPricingCards.map(function (element) {
            var currencyCard = element.getAttribute('data-currency');
            var currencyCardTitle = element.querySelector('.detailed-product-card-exchange__description');
            _this.currencyCardTitle(currencyCardTitle);
            if (currencyCard) {
                element.classList.add('d-none');
            }
            else {
                element.classList.remove('d-none');
            }
            if (currency) {
                if (currencyCard == currency) {
                    element.classList.remove('d-none');
                }
            }
            else {
                if (_this.currencyStorage) {
                    if (currencyCard == _this.currencyStorage) {
                        element.classList.remove('d-none');
                    }
                }
                else {
                    if (currencyCard == "GBP") {
                        element.classList.remove('d-none');
                    }
                }
            }
        });
        this.currencyPricingTerms.map(function (element) {
            var currencyCard = element.getAttribute('data-currency-value');
            if (currencyCard) {
                element.classList.add('d-none');
            }
            else {
                element.classList.remove('d-none');
            }
            if (currency) {
                if (currencyCard == currency) {
                    element.classList.remove('d-none');
                }
            }
            else {
                if (_this.currencyStorage) {
                    if (currencyCard == _this.currencyStorage) {
                        element.classList.remove('d-none');
                    }
                }
                else {
                    if (currencyCard == "GBP") {
                        element.classList.remove('d-none');
                    }
                }
            }
        });
        this.supportedCurrenciesRendered = true;
    };
    DetailedProductCardExchange.prototype.currencyCardTitle = function (element) {
        if (!this.supportedCurrenciesRendered) {
            var elementHtml = element.innerHTML;
            elementHtml = elementHtml.trim().replace(/ /g, "");
            elementHtml = elementHtml.toLowerCase();
            if (elementHtml == 'supportedcurrencies') {
                var closestContainer = element.closest('.detailed-product-card-exchange__currency-js');
                var valueContainer = closestContainer.querySelector('.detailed-product-card-exchange__item-title');
                valueContainer.classList.add('product-offering-exchange__pricing-title--small');
                var value = valueContainer.innerHTML;
                value = value.trim().replace(/ /g, "");
                var output = "";
                var outputOther = "SUPPORTED CURRENCIES:<br>";
                var splittedCurrencies = value.split(',');
                if (splittedCurrencies.length > 5) {
                    valueContainer.innerHTML = "";
                    for (var index = 0; index < 5; index++) {
                        output += splittedCurrencies[index] + ", ";
                    }
                    for (var index = 5; index < splittedCurrencies.length; index++) {
                        if ((index + 1) == splittedCurrencies.length) {
                            outputOther += splittedCurrencies[index];
                        }
                        else {
                            outputOther += splittedCurrencies[index] + ", ";
                        }
                    }
                    output +=
                        " Other <span title=\"" + outputOther + "\" data-title=\"" + outputOther + "\">\n\t\t\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-tooltip\" class=\"icon \"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n\t\t\t\t\t\t\t\t<path fill=\"#0089FF\" fill-rule=\"evenodd\" d=\"M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-1-3h2v-2H7v2zm0-4.004h2V3H7v5.996z\"></path>\n\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t</span>\n\t\t\t\t\t\t";
                    valueContainer.innerHTML = output;
                }
            }
        }
    };
    DetailedProductCardExchange.prototype.buttonContainer = function (storage) {
        var eligibilityExists = false;
        var eligibilityResult = '';
        var eligibilityLeadId = '';
        var eligibilityModalId = '';
        this.containerButtons.map(function (element) {
            element.classList.add('d-none');
            var buttonContainer = element.getAttribute('data-buttonclass');
            var button = element.querySelector('.button');
            var buttonModalId = button.getAttribute('data-modal');
            for (var key in storage) {
                if (buttonModalId === key) {
                    eligibilityExists = true;
                    eligibilityResult = storage[key].result;
                    eligibilityLeadId = storage[key].leadID;
                    eligibilityModalId = key;
                }
            }
        });
        this.buttonStorage(eligibilityExists, eligibilityResult, eligibilityLeadId, eligibilityModalId);
    };
    DetailedProductCardExchange.prototype.buttonStorage = function (exists, result, leadid, modalId) {
        if (exists === void 0) { exists = false; }
        if (result === void 0) { result = ''; }
        if (leadid === void 0) { leadid = ''; }
        if (modalId === void 0) { modalId = ''; }
        if (exists || this.queryStringCheck) {
            if (result == "apply" || this.queryStringCheck) {
                this.containerButtons.map(function (element) {
                    var buttonClass = element.getAttribute('data-buttonclass');
                    var button = element.querySelector('.button');
                    if (buttonClass === 'Apply' || buttonClass === 'Compare') {
                        element.classList.remove('d-none');
                        if (buttonClass === 'Apply') {
                            button.setAttribute('href', 'javascript:void(0)');
                            button.setAttribute('data-leadid', leadid);
                        }
                    }
                });
                this.containerEligibilityMessage.classList.add('detailed-product-card-exchange__eligibility-message--eligible');
                this.containerEligibilityMessage.innerHTML = "You are eligible for this product.";
            }
            else if (result == "callmeback") {
                this.containerButtons.map(function (element) {
                    var buttonClass = element.getAttribute('data-buttonclass');
                    var button = element.querySelector('.button');
                    if (buttonClass === 'CallMeBack' || buttonClass === 'Compare') {
                        element.classList.remove('d-none');
                        if (buttonClass === 'CallMeBack') {
                            button.setAttribute('data-leadid', leadid);
                        }
                    }
                });
                this.containerEligibilityMessage.classList.add('detailed-product-card-exchange__eligibility-message--eligible');
                this.containerEligibilityMessage.innerHTML = "You are eligible for this product.";
            }
            else if (result == "contactus") {
                this.containerButtons.map(function (element) {
                    var buttonClass = element.getAttribute('data-buttonclass');
                    var button = element.querySelector('.button');
                    if (buttonClass === 'ContactUs' || buttonClass === 'Compare') {
                        element.classList.remove('d-none');
                    }
                });
                this.containerEligibilityMessage.classList.add('detailed-product-card-exchange__eligibility-message--invalid');
                this.containerEligibilityMessage.innerHTML = "You are not eligible for this product. <a href=\"javascript:;\" class=\"js-apply-now-modal-open js-recheck-eligibility\" data-modal=\"" + modalId + "\">Recheck</a>";
            }
            else if (result == "notvalid") {
                this.containerButtons.map(function (element) {
                    var buttonClass = element.getAttribute('data-buttonclass');
                    var button = element.querySelector('.button');
                    if (buttonClass === 'ContactUs' || buttonClass === 'Compare') {
                        element.classList.remove('d-none');
                    }
                });
                this.containerEligibilityMessage.classList.add('detailed-product-card-exchange__eligibility-message--invalid');
                this.containerEligibilityMessage.innerHTML = "You are not eligible for this product. <a href=\"javascript:;\" class=\"js-apply-now-modal-open js-recheck-eligibility\" data-modal=\"" + modalId + "\">Recheck</a>";
            }
            else {
                this.containerButtons.map(function (element) {
                    var buttonClass = element.getAttribute('data-buttonclass');
                    var button = element.querySelector('.button');
                    if (buttonClass === 'Eligibility' || buttonClass === 'Compare') {
                        element.classList.remove('d-none');
                    }
                });
            }
        }
        else {
            var eligibilityExists_1 = false;
            this.containerButtons.map(function (element) {
                var buttonClass = element.getAttribute('data-buttonclass');
                if (buttonClass === 'Eligibility') {
                    eligibilityExists_1 = true;
                }
            });
            this.containerButtons.map(function (element) {
                var buttonClass = element.getAttribute('data-buttonclass');
                var button = element.querySelector('.button');
                if (eligibilityExists_1 === false) {
                    if (buttonClass === 'ContactUs' || buttonClass === 'Compare' || buttonClass === 'salesforceApplyNow') {
                        element.classList.remove('d-none');
                    }
                }
                else {
                    if (buttonClass === 'Eligibility' || buttonClass === 'Compare' || buttonClass === 'salesforceApplyNow') {
                        element.classList.remove('d-none');
                    }
                }
            });
        }
    };
    DetailedProductCardExchange.prototype.recheckEligibility = function (element) {
        if (element) {
            var modalId = element.getAttribute('data-modal');
            this.containerEligibilityMessage.innerHTML = '';
            delete this.eligibilityStorage[modalId];
            localStorage.setItem('eligibility', JSON.stringify(this.eligibilityStorage));
            this.buttonContainer(this.eligibilityStorage);
        }
    };
    DetailedProductCardExchange.prototype.actionApplyNow = function (leadId, productName) {
        if (leadId === void 0) { leadId = ''; }
        if (productName === void 0) { productName = ''; }
        var messageEligiblility = this.containerEligibilityMessage;
        var postData = '';
        if (this.queryStringCheck) {
            postData += 'operation=submit_seafarer_referral&';
            postData += 'referralCode=' + this.queryStringValue + '&';
        }
        else {
            postData += 'operation=submit&';
            postData += 'leadID=' + leadId + '&';
        }
        postData += 'category=individual&';
        postData += 'productName=' + productName + '&';
        postData += 'appID=' + this.checkEligibility.applicationID + '&';
        postData += 'productID=' + this.checkEligibility.applicationProductID + '&';
        var analyticsService = new AnalyticsService();
        var url = "/services/SubmitWINLead.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            var json = response.data;
            if (json) {
                var errors = json.Errors;
                if (errors.length > 0) {
                    errors.forEach(function (error) {
                        analyticsService.dtmRecordSiteError('noerrorcode|' + error + '|' + url);
                        messageEligiblility.classList.add('detailed-product-card-exchange__eligibility-message--invalid');
                        if (error.includes('Unknown product')) {
                            messageEligiblility.innerHTML = 'Invalid request';
                        }
                        if (error.includes('Authorization')) {
                            messageEligiblility.innerHTML = 'Invalid request';
                        }
                        if (error.includes('undocumented')) {
                            messageEligiblility.innerHTML = 'Request failed – try again later';
                        }
                        if (error.includes('existing')) {
                            messageEligiblility.innerHTML = 'Your request has already been submitted';
                        }
                    });
                }
                else {
                    var resources = json.Resources;
                    if (resources) {
                        var lmm = resources.LMM;
                        if (lmm) {
                            window.location = lmm;
                            analyticsService.dtmFormComplete('complete', leadId);
                        }
                    }
                }
            }
        }).catch(function (response) {
            analyticsService.dtmRecordSiteError('noerrorcode|' + response + '|' + url);
        });
    };
    DetailedProductCardExchange.prototype.urlParams = function (name) {
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results == null) {
            return null;
        }
        else {
            return decodeURI(results[1]) || 0;
        }
    };
    return DetailedProductCardExchange;
}(Base));
export { DetailedProductCardExchange };



//////////////////
// WEBPACK FOOTER
// ./components/detailed-product-card-exchange/detailed-product-card-exchange.component.ts
// module id = 263
// module chunks = 0